import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <g clipPath="url(#clip0_2332_38358)">
        <g filter="url(#filter0_d_2332_38358)">
          <path
            fill="url(#paint0_linear_2332_38358)"
            d="M16.582 8.25c2.428 1.373 3.982 3.391 4.709 6.005.382 1.373.428 2.768.203 4.172-.098.604-.267 1.18-.625 1.69-.708.998-1.683 1.546-2.949 1.549-3.944.004-7.887-.005-11.829.004A3.59 3.59 0 012.621 19c-.259-.972-.32-1.952-.247-2.94a9.71 9.71 0 015.759-8.176l.105-.049c-.143-.145-.283-.279-.415-.422A4.293 4.293 0 016.687 4.99c-.141-1.071.649-1.854 1.603-2.044.504-.1.994-.056 1.462.152.07.03.11.02.164-.03 1.158-1.034 3-1.024 4.149.023.06.057.103.04.164.014.89-.356 1.734-.285 2.48.326.55.45.72.994.571 1.89-.077.283-.105.416-.22.721-.234.63-.684 1.163-1.183 1.624l-.148.134c-.007.005-.007.012-.01.016.289.146.584.277.863.434z"
            shapeRendering="crispEdges"
          ></path>
        </g>
        <g filter="url(#filter1_d_2332_38358)">
          <path
            fill="url(#paint1_linear_2332_38358)"
            d="M16 14.4h-2V18h-4v-3.6H8L12 9l4 5.4z"
          ></path>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_2332_38358"
          width="27.284"
          height="27.371"
          x="-1.654"
          y="-1.701"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0.197999 0 0 0 0 0.478402 0 0 0 0 0.816667 0 0 0 0.57 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2332_38358"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_2332_38358"
            result="shape"
          ></feBlend>
        </filter>
        <filter
          id="filter1_d_2332_38358"
          width="12"
          height="13"
          x="6"
          y="8"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="1"></feOffset>
          <feGaussianBlur stdDeviation="1"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0.00392157 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 0.37 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2332_38358"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_2332_38358"
            result="shape"
          ></feBlend>
        </filter>
        <linearGradient
          id="paint0_linear_2332_38358"
          x1="11.988"
          x2="15.331"
          y1="2.299"
          y2="21.747"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF6FF"></stop>
          <stop offset="1" stopColor="#ACD7FF" stopOpacity="0.78"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_2332_38358"
          x1="8"
          x2="16.062"
          y1="9"
          y2="9.055"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00B2FF"></stop>
          <stop offset="1" stopColor="#0047FF"></stop>
        </linearGradient>
        <clipPath id="clip0_2332_38358">
          <path fill="#fff" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
